import { en } from './en';
import { el } from './el';
import { tr } from './tr';
import { Language } from '../constants';

const translations = {
  EN: en,
  EL: el,
  TR: tr,
} as const;

export type Strings = typeof en;

export { useA11y } from './a11y';
export type { A11yStrings } from './a11y';

export function useStrings(lang: Language): Strings {
  return translations[lang];
}
